export const HttpStatusCode = {
  OK: 200,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500
} as const

export type HttpStatusCodeType = (typeof HttpStatusCode)[keyof typeof HttpStatusCode]
